import { useEffect, useRef, useState } from 'react';
import { faqs } from '@/data/faq';

export default function FaqSection() {
  const ref = useRef<HTMLElement>(null);
  const [open, setOpen] = useState<number | null>(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('opacity-100', 'translate-y-0');
          e.target.classList.remove('opacity-0', 'translate-y-6');
        }
      }),
      { threshold: 0.1 }
    );
    ref.current?.querySelectorAll('.anim').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="faq" ref={ref} className="w-full py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          {/* Left */}
          <div className="lg:w-80 flex-shrink-0">
            <div className="anim opacity-0 translate-y-6 transition-all duration-500 sticky top-24">
              <span className="inline-flex items-center gap-2 text-xs font-bold text-primary bg-[#f0f7ff] border border-[#dbeafe] px-3 py-1.5 rounded-full uppercase tracking-widest mb-4">
                SSS
              </span>
              <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4 tracking-tight leading-tight">
                Sık Sorulan<br />Sorular
              </h2>
              <p className="text-sm text-slate-500 leading-relaxed mb-6">
                Kombi tamiri ve bakımı hakkında merak ettiğiniz her şeyin cevabı burada. Başka sorunuz varsa bizi arayın.
              </p>
              <a
                href="tel:05332836679"
                className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-bold text-sm px-6 py-3 rounded-full transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill" />
                Bize Sorun
              </a>
            </div>
          </div>

          {/* Right accordion */}
          <div className="flex-1 flex flex-col gap-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="anim opacity-0 translate-y-6 transition-all duration-500 bg-white rounded-2xl border border-[#dbeafe] overflow-hidden"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer hover:bg-[#f0f7ff] transition-colors"
                >
                  <span className="text-sm font-bold text-slate-900 leading-snug">{faq.q}</span>
                  <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${open === i ? 'bg-primary text-white rotate-45' : 'bg-[#f0f7ff] text-primary'}`}>
                    <i className="ri-add-line text-base" />
                  </div>
                </button>
                {open === i && (
                  <div className="px-6 pb-5">
                    <p className="text-sm text-slate-500 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}